<template>
    <div class="craft-info-tab" ref="wrapper">
        <iframe v-if="url" ref="iframe" :src="url" frameborder="0" width="100%" height="100%"></iframe>
        <Empty v-else emptyType="product" marginTop="200px" emptyText="暂无工艺详情"></Empty>
    </div>
</template>
<script>
import Empty from '@/components/Empty.vue'
export default {
    name: 'CraftInfoTab',
    components: {
        Empty,
    },
    props: {
        detail: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            url: '',
        }
    },
    mounted() {
        if (this.detail.ord && this.detail.ord.po_no) {
            this.url = `http://datacentre.bocini.cn/#/printTechniqueOrder?code=${this.detail.ord.po_no}`;
        } else {
            this.url = '';
        }
    },
}
</script>
<style lang="scss" scoped>
.craft-info-tab {
    width: 100%;
    height: 800px;
    overflow: hidden;

}
</style>
